import React from 'react'
import {browserHistory, Route, Router} from 'react-router'

import Exercice from './Page/Exercice/'
import Document from './Page/Document/'

export default _ =>
    <Router history={browserHistory}>
        {/*<Route path="/crm" component={Dashboard}/>*/}
        <Route path="/pedagogie/document" component={Document}/>
        <Route path="/pedagogie/exercice" component={Exercice}/>
    </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Pedagogie/index.js